"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'area-chart': 'ea9b',
    'bar-chart-3d': 'ea9c',
    'entities-list': 'ea9e',
    'entity-details': 'ea9f',
    'line-chart': 'eaa0',
    'map': 'eaa1',
    'pie-chart-3d': 'eaa2',
    'pie-chart': 'eaa3',
    'table': 'eaa4',
    'adjustments': 'eaa5',
    'ascending': 'eaa6',
    'descending': 'eaa7',
    'duplicate': 'eaa8',
    'export': 'eaa9',
    'import': 'eaaa',
    'new-tab': 'eaab',
    'revert': 'eaac',
    'save-as': 'eaad',
    'UEL': 'eaae',
    'skyscrapers': 'ea8a',
    'radio-frequencies': 'ea8b',
    'buildings': 'ea8c',
    'antenna': 'ea8d',
    '3d-perspective-view': 'ea8e',
    'stuck-on-roundabout': 'ea8f',
    'swerve': 'ea90',
    'pencil-tool-shape': 'ea91',
    'buy-refurbished': 'ea92',
    'buy-new': 'ea93',
    '1-over-01': 'ea94',
    'lights-setting': 'ea95',
    'lights-error': 'ea96',
    'lights': 'ea97',
    'scanner': 'ea98',
    'responsive': 'ea99',
    'scanner-asset': 'ea9a',
    'invisible': 'ea84',
    'visible': 'ea85',
    'temperature-freezing': 'ea86',
    'temperature-hot': 'ea87',
    'email-read': 'ea88',
    'volume-high': 'ea89',
    'ellipsis-vertical': 'ea72',
    'filter': 'ea75',
    'home': 'ea76',
    'portfolio-cost': 'ea6d',
    'portfolio-savings': 'ea6e',
    'CMX': 'ea6f',
    'thermostat': 'ea70',
    'grid': 'ea71',
    'briefcase': 'ea73',
    'flight-chart': 'ea74',
    'clipboard': 'ea77',
    'user-operations': 'ea78',
    'organization': 'ea79',
    'PTMD': 'ea7a',
    'report': 'ea7b',
    'clockwise': 'ea7c',
    'monitor-eye': 'ea7d',
    'location': 'ea7e',
    'sites': 'ea7f',
    'footprint': 'ea80',
    'graduation': 'ea81',
    'trend': 'ea82',
    'buildings1': 'ea83',
    'app-launcher': 'e9ca',
    'double-caret-left': 'ea67',
    'double-caret-right': 'ea68',
    'ellipsis-horizontal': 'ea69',
    'share': 'ea6a',
    'shipping': 'ea6b',
    'wind-snow': 'e900',
    'wind': 'e901',
    'clear-night': 'e902',
    'sun': 'e903',
    'cloud': 'e904',
    'cloud-drizzle': 'e905',
    'cloud-sun': 'e906',
    'cloud-hail-mixed': 'e907',
    'cloud-hail-mixed-drizzle': 'e908',
    'cloud-hail': 'e909',
    'sun-haze': 'e90a',
    'cloud-heavy-fog': 'e90b',
    'cloud-heavy-rain': 'e90c',
    'cloud-heavy-snow': 'e90d',
    'hurricane': 'e90e',
    'cloud-snow-rain': 'e90f',
    'cloud-light-fog': 'e910',
    'cloud-light-rain': 'e911',
    'cloud-light-snow': 'e912',
    'cloud-thunderstorm-rain': 'e913',
    'cloud-moderate-fog': 'e914',
    'na': 'e915',
    'cloud-rain': 'e916',
    'sun-sandstorm': 'e917',
    'clouds-scattered': 'e918',
    'cloud-sun-rain': 'e919',
    'cloud-sun-thunderstorm-rain': 'e91a',
    'cloud-smoke': 'e91b',
    'snow': 'e91c',
    'sunrise': 'e91d',
    'cloud-thunderstorm': 'e921',
    'tornado': 'e922',
    'tropical-storm': 'e923',
    'water': 'e924',
    'call-center': 'e91e',
    'user-edit': 'e91f',
    'entrance-guard': 'e920',
    'user-group': 'e925',
    'user-group-add': 'e926',
    'security-guard': 'e927',
    'motion-detection': 'e928',
    'user-remove': 'e929',
    'user-search': 'e92a',
    'user-selected': 'e92b',
    'user-settings': 'e92c',
    'user': 'e92d',
    'user-add': 'e92e',
    'uppercase': 'e92f',
    'symbols': 'e930',
    'numbers': 'e931',
    'lowercase': 'e932',
    'intercept': 'e933',
    'email': 'e934',
    '1-over-0': 'e935',
    'youtube': 'e936',
    'twitter': 'e937',
    'tag': 'e938',
    'facebook': 'e939',
    'credit-card': 'e93a',
    'coming-home-settings': 'e93b',
    'away-from-home-settings': 'e93c',
    'protection': 'e93d',
    'protection-secure': 'e93e',
    'protection-not-secure': 'e93f',
    'protection-settings': 'e940',
    'home-alert': 'e941',
    'home-settings': 'e942',
    'leaving-home-settings': 'e943',
    'globe-download': 'e944',
    'globe-expand': 'e945',
    'gas': 'e946',
    'globe': 'e947',
    'globe-info': 'e948',
    'globe-layer': 'e949',
    'coffee': 'e94a',
    'measure': 'e94b',
    'globe-move': 'e94c',
    'neighbor': 'e94d',
    'globe-new': 'e94e',
    'globe-on-the-web': 'e94f',
    'globe-pan': 'e950',
    'globe-reader': 'e951',
    'globe-refresh': 'e952',
    'globe-time-zone': 'e953',
    'globe-upload': 'e954',
    'veranda': 'e955',
    'globe-view': 'e956',
    'saturation': 'e957',
    'contrast': 'e958',
    'folder': 'e959',
    'folder-open': 'e95a',
    'folder-music': 'e95b',
    'document-cut': 'e95c',
    'document-alarm': 'e95d',
    'document-variable': 'e95e',
    'document-command-file': 'e95f',
    'document-settings': 'e960',
    'document-user-profile': 'e961',
    'document-global': 'e962',
    'document-publish': 'e963',
    'document-deploy-client': 'e964',
    'document-order-processing': 'e965',
    'document-report': 'e966',
    'document-parameter': 'e967',
    'document-compliation': 'e968',
    'document-workingstation-default': 'e969',
    'document-regular': 'e96a',
    'document-template': 'e96b',
    'document-sorting': 'e96c',
    'document-weather': 'e96d',
    'document-flight-plan': 'e96e',
    'document-link': 'e96f',
    'document-blank': 'e970',
    'document-standard': 'e971',
    'document-sync': 'e972',
    'document-photo': 'e973',
    'document-confirm': 'e974',
    'document-certification': 'e975',
    'document-search': 'e976',
    'document-new': 'e977',
    'document-edit': 'e978',
    'document-delete': 'e979',
    'document-history': 'e97a',
    'wifi': 'e97b',
    'network': 'e97c',
    'gateway-set': 'e97d',
    'serialport-test': 'e97e',
    'battery-empty': 'e97f',
    'battery-low': 'e980',
    'battery-mid': 'e981',
    'battery-full': 'e982',
    'plug': 'e983',
    'dongle-update': 'e984',
    'keyboard-input': 'e985',
    'camcorder': 'e986',
    'cable-rs232': 'e987',
    'smartphone': 'e988',
    'devices-multiple': 'e989',
    'surveillance': 'e98a',
    'surveillance-refresh': 'e98b',
    'connection-unsuccessful': 'e98c',
    'connection-successful': 'e98d',
    'connection-expensive': 'e98e',
    'connection': 'e98f',
    'display-clean': 'e990',
    'display-multiple': 'e991',
    'display-patrol': 'e992',
    'display-live': 'e993',
    'display': 'e994',
    'display-map': 'e995',
    'display-configuration': 'e996',
    'firmware-update': 'e997',
    'display-adjust': 'e998',
    'ipcamera-online': 'e999',
    'ipcamera-offline': 'e99a',
    'ipcamera-login': 'e99b',
    'spherecamera-login': 'e99c',
    'spherecamera-offline': 'e99d',
    'spherecamera-online': 'e99e',
    'ipcamera': 'e99f',
    'semi-spherecamera-login': 'e9a0',
    'semi-spherecamera-offline': 'e9a1',
    'semi-spherecamera-online': 'e9a2',
    'asset': 'e9a3',
    'asset-search': 'e9a4',
    'asset-configuration': 'e9a5',
    'videocamera': 'e9a6',
    'record-close': 'e9a7',
    'videopoint-add': 'e9a8',
    'videocamera-login': 'e9a9',
    'videopoint-delete': 'e9aa',
    'alarm-settings': 'e9ab',
    'clock-timesettings': 'e9ac',
    'alarm-add': 'e9ad',
    'alarm-input': 'e9ae',
    'clock-switchtime': 'e9af',
    'fixedcamera': 'e9b0',
    'fixedcamera-disabled': 'e9b1',
    'fixedcamera-enabled': 'e9b2',
    'device-selected': 'e9b3',
    'device-group': 'e9b4',
    'device-group-delete': 'e9b5',
    'device-group-add': 'e9b6',
    'device-management': 'e9b7',
    'device-login': 'e9b8',
    'device-add': 'e9b9',
    'mobile-offline': 'e9ba',
    'ip-conflict': 'e9bb',
    'mobile-online': 'e9bc',
    'server-pause': 'e9bd',
    'database': 'e9be',
    'database-configuration': 'e9bf',
    'database-refresh': 'e9c0',
    'node-combine': 'e9c1',
    'node-branch': 'e9c2',
    'node-start': 'e9c3',
    'node-stop': 'e9c4',
    'node-transfer': 'e9c5',
    'increasing': 'e9c6',
    'delivery-missed': 'e9c7',
    'milestone-missed': 'e9c8',
    'milestone-achieved': 'e9c9',
    'bolt': 'ea6c',
    'tag-found': 'e9cb',
    'gateway-lost': 'e9cc',
    'gateway-found': 'e9cd',
    'tag-lost': 'e9ce',
    'tint': 'e9cf',
    'level': 'e9d1',
    'dashboard': 'e9d2',
    'ip-set': 'e9d3',
    'ec-server-connect': 'e9d4',
    'rate-bounce': 'e9d5',
    'server-site': 'e9d6',
    'graph-line': 'e9d7',
    'graph-drop': 'e9d8',
    'graph-bar': 'e9d9',
    'server-ip-address': 'e9da',
    'reader': 'e9db',
    'reader-management': 'e9dc',
    'reader-failed': 'e9dd',
    'reader-disabled': 'e9de',
    'reader-placement': 'e9df',
    'server-search': 'e9e0',
    'server-offline': 'e9e1',
    'server-configuration': 'e9e2',
    'centralcontroller': 'e9e3',
    'switchyard-reduce': 'e9e4',
    'sleep-settings': 'e9e5',
    'slidercontrols-minus': 'e9e6',
    'slidercontrols-plus': 'e9e7',
    'enable-disable': 'e9e8',
    'serial-config': 'e9e9',
    'brightness': 'e9ea',
    'switcher': 'e9eb',
    'joystick': 'e9ec',
    'curtain-control': 'e9ed',
    'ptz-control': 'e9ee',
    'control-areas': 'e9ef',
    'centralcontroller-increase': 'e9f0',
    'centralcontroller-reduce': 'e9f1',
    'centralcontroller-configuration': 'e9f2',
    'switchyard-increase': 'e9f3',
    'switchyard': 'e9f4',
    'timeline': 'e9f5',
    'checkbox': 'e9f6',
    'image-responsive': 'e9f7',
    'thumbnail': 'e9f8',
    'layer': 'e9f9',
    'bookmark': 'e9fa',
    'bookmark-added': 'e9fb',
    'bookmark-remove': 'e9fc',
    'bookmark-add': 'e9fd',
    'timer': 'e9fe',
    'submenu': 'e9ff',
    'holiday-group': 'ea00',
    'daylight-saving': 'ea01',
    'time': 'ea02',
    'tree-chart': 'ea03',
    'menu-physical': 'ea04',
    'template': 'ea05',
    'expenses': 'ea06',
    'attachment': 'ea07',
    'food': 'ea08',
    'tree-chart-disabled': 'ea09',
    'bar-status': 'ea0a',
    'bar-action': 'ea0b',
    'menu-dropdown': 'ea0c',
    'toolbar-column-active': 'ea0d',
    'call-contacts': 'ea0e',
    'call-missed': 'ea0f',
    'call-hangup': 'ea10',
    'call-forward': 'ea11',
    'email-unread': 'ea12',
    'message': 'ea13',
    'message-voice': 'ea14',
    'message-dialog': 'ea15',
    'message-number': 'ea16',
    'message-new': 'ea17',
    'volume-low': 'ea18',
    'volume-off': 'ea19',
    'music': 'ea1a',
    'dvr': 'ea1b',
    'channel-next': 'ea1c',
    'channel-previous': 'ea1d',
    'frame-previous': 'ea1e',
    'frame-next': 'ea1f',
    'file-next': 'ea20',
    'file-previous': 'ea21',
    'slow-forward': 'ea22',
    'slow-backward': 'ea23',
    'fast-forward': 'ea24',
    'skip-to-start': 'ea25',
    'skip-to-end': 'ea26',
    'fast-backward': 'ea27',
    'play': 'ea28',
    'playback': 'ea29',
    'playback-play': 'ea2a',
    'playback-record': 'ea2b',
    'playback-stop': 'ea2c',
    'arrow-right': 'ea2d',
    'arrow-up': 'ea2e',
    'node-sequence': 'ea2f',
    'node-select': 'ea30',
    'node-connect': 'ea31',
    'node-action': 'ea32',
    'move': 'ea33',
    'arrow-left-and-right': 'ea34',
    'arrow-left': 'ea35',
    'arrow-down': 'ea36',
    'select-all': 'ea37',
    'select': 'ea38',
    'communication-start': 'ea39',
    'communication-pause': 'ea3a',
    'communication': 'ea3b',
    'badge-delete': 'e9d0',
    'power': 'ea3c',
    'caret-up': 'ea3d',
    'badge-important': 'ea3e',
    'menu': 'ea3f',
    'scan': 'ea40',
    'badge-warning': 'ea41',
    'badge-info': 'ea42',
    'notification': 'ea43',
    'badge-plus': 'ea44',
    'unlock': 'ea45',
    'lock': 'ea46',
    'undo': 'ea47',
    'settings': 'ea48',
    'search': 'ea49',
    'save': 'ea4a',
    'refresh': 'ea4b',
    'redo': 'ea4c',
    'print': 'ea4d',
    'link': 'ea4e',
    'home1': 'ea4f',
    'flag': 'ea50',
    'filter1': 'ea51',
    'favorite': 'ea52',
    'edit': 'ea53',
    'delete': 'ea54',
    'close': 'ea55',
    'check': 'ea56',
    'caret-right': 'ea57',
    'caret-left': 'ea58',
    'caret-down': 'ea59',
    'camera': 'ea5a',
    'calendar': 'ea5b',
    'exit-fullscreen': 'ea5c',
    'enter-fullscreen': 'ea5d',
    'file-download': 'ea5e',
    'exit': 'ea5f',
    'expand': 'ea60',
    'collapse': 'ea61',
    'cloud-upload': 'ea62',
    'cloud-download': 'ea63',
    'badge-check': 'ea64',
    'badge-stop': 'ea65',
    'badge-help': 'ea66'
};
